import { SET_FETCH_ADS, SET_LOADING, SET_ERROR } from "../action/actionTypes";

const initialState = {
  ads: [], // Prefer an array over null for lists
  loading: false,
  error: null,
};

const adsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FETCH_ADS:
      return { ...state, ads: action.payload, error: null };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload, ads: [] }; // Reset ads on error
    default:
      return state;
  }
};

export default adsReducer;
